import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import style from "./DiaryEntry.module.sass";
import { callApi, } from "../../../../helpers";
import List from "../../../List/List";
import Comment from "./Comment/Comment";
import CommentForm from "../CommentForm/CommentForm";

function DiaryEntry(props) {
  const {
    id,
    alertLevel,
    commentsCount,
    commentsPath,
    createdAt,
    creator,
    manager,
    managePath,
    status,
    text,
    onManage,
    translations
  } = props;
  const rootRef = useRef();
  const [showComments, setShowComments] = useState(false);
  const [showCommentForm, setShowCommentForm] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [queryPath, setQueryPath] = useState(commentsPath);
  const [numComments, setNumComments] = useState(commentsCount);
  const [isTypingComment, setIsTypingComment] = useState(false);

  useEffect(() => {
    // addListener();
  }, []);

  const refreshList = () => {
    const newQueryPath = `${commentsPath}?random=${crypto.randomUUID()}`;
    setQueryPath(newQueryPath);
  };

  const onClickDiaryEntry = (e) => {
    e.preventDefault();
    if (expanded) {
      setShowComments(false);
      setExpanded(false);
      return;
    }
    setExpanded(true);
    if (numComments > 0) {
      callApi(commentsPath, "GET", "json", onCommentsSuccess);
    }
  }

  const onClickManage = (e) => {
    e.stopPropagation();
    callApi(managePath, "PATCH", "", onManageSuccess);
  }

  const onCommentsSuccess = (data) => {
    setShowComments(data.items.length > 0);
  }

  const onManageSuccess = () => {
    onManage();
  }

  const onClickShowCommentForm = (e) => {
    e.stopPropagation();
    setExpanded(true);
    setShowCommentForm(true);
  }

  const onCommentSubmit = (e) => {
    setShowCommentForm(false);
    refreshList();
    setShowComments(true);
  }

  const onCommentsLoaded = (items, data) => {
    // console.log(items);
    if (items.length > numComments) {
      setNumComments(items.length);
      setShowComments(true);
    }
  }

  const onClickCancel = () => {
    setShowCommentForm(false);
  }

  const renderComment = (item) => {
    return (
      <Comment key={item.id} {...item} />
    )
  }

  const renderAlertLevel = () => {
    switch (alertLevel) {
      case "red":
        return '🚨';
      case "yellow":
        return '⚠️';
      default:
        return null;
    }
  }

  let rootClass = `${style.DiaryEntry} ${expanded ? style.expanded : ''} ${isTypingComment ? style.typing : ''}`;

  return (
    <div className={rootClass} id={`diary-entry-${id}`} key={id} ref={rootRef} onClick={onClickDiaryEntry}>
      <div className={style.header}>
        <div className={style.createdAt}>{createdAt}</div>
        <div className={style.creator}>{creator.name}</div>
        {alertLevel !== 'normal' && (
          <div className={style.alertLevel}>{renderAlertLevel()}</div>
        )}
      </div>
      <div className={style.text}>{text}</div>
      {manager && <div className={style.manager}>{translations.managedBy}</div>}
      {numComments > 0 &&
        <div className={style.commentsCount}>
          {numComments} <i className={`fa fa-comment`}></i>
        </div>
      }
      {showComments &&
        <div className={style.comments}>
          <List
            baseQuery={queryPath}
            renderItem={renderComment}
            showPagination={false}
            onItemsLoaded={onCommentsLoaded}
          />
        </div>}
      {showCommentForm &&
        <CommentForm
          translations={translations.commentForm}
          newCommentPath={commentsPath}
          onSubmit={onCommentSubmit}
          onCancel={onClickCancel}
          onTypingChange={setIsTypingComment}
        />
      }
      {status === "pending" &&
        <div className={style.actions}>
          <div className={style.commentAction} onClick={onClickShowCommentForm}>{translations.actions.comment}</div>
          <div className={style.manageAction} onClick={onClickManage}>{translations.actions.manage}</div>
        </div>}
    </div>
  );
}

DiaryEntry.propTypes = {};

DiaryEntry.defaultProps = {};

export default DiaryEntry;
